<template>
  <v-card>
    <v-card-title class="grey--text text-subtitle-1">
      Analisi Clienti
      <v-spacer />
      <v-switch
        inset
        v-model="usa_contabili"
        label="Usa Contabili"
        class="mr-4"
      ></v-switch>
      <v-switch inset v-model="show_confronta" label="Confronta"></v-switch>
    </v-card-title>
    <v-card-subtitle class="mt-1">
      <v-row no-gutters align="center">
        <v-col cols="3">
          <v-select
            :items="periodo_list"
            v-model="periodo"
            label="Periodo"
            item-value="value"
            item-text="label"
            hide-details
            dense
            outlined
          />
        </v-col>
        <v-select
          v-if="show_confronta"
          :items="lista_anni_rif"
          v-model="anno_rif"
          item-text="label"
          item-value="value"
          label="Anno di Riferimento"
          hide-details
          dense
          outlined
          class="ml-2"
          style="max-width: 150px"
        />
      </v-row>
      <!-- KPI -->
      <v-row no-gutters class="mt-3" v-if="!loading && lista_filtered.length">
        <v-col cols="auto">
          <v-chip small color="primary" outlined>
            <v-icon left small>mdi-account-group</v-icon>
            Clienti attivi: {{ kpi.n_clienti }}
          </v-chip>
        </v-col>
      </v-row>
    </v-card-subtitle>
    <v-card-text class="mt-0">
      <template v-if="loading">
        <v-row class="pt-12" justify="center">
          <v-progress-circular width="2" color="green" indeterminate />
        </v-row>
      </template>
      <template v-else>
        <v-row>
          <v-col cols="12">
            <v-card elevation="0" class="ml-n4">
              <v-card-subtitle class="mb-n2">
                <v-row no-gutters class="mt-n4">
                  <v-col cols="2">
                    <v-text-field
                      v-model="cliente_search"
                      dense
                      hide-details
                      outlined
                      prepend-inner-icon="mdi-magnify"
                      placeholder="Cerca Cliente ..."
                    />
                  </v-col>
                </v-row>
                <v-row class="mt-2" align="center">
                  <!-- Cliente -->
                  <v-col :cols="show_confronta ? 2 : 3" class="font-weight-medium text-caption grey--text d-flex align-center">
                    Cliente
                    <v-btn icon x-small @click="sort_cliente = !sort_cliente; sort_by = 'Cliente'">
                      <v-icon small>{{ sort_cliente ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                    </v-btn>
                  </v-col>
                  <!-- Proporzione -->
                  <v-col :cols="show_confronta ? 2 : 3" class="font-weight-medium text-caption grey--text pl-0">
                    Proporzione
                  </v-col>
                  <!-- Blu -->
                  <v-col :cols="show_confronta ? 1 : 2" class="font-weight-medium text-caption d-flex justify-end align-center pr-2" style="color: #448AFF;">
                    Blu
                    <v-btn icon x-small @click="sort_blu = !sort_blu; sort_by = 'Blu'">
                      <v-icon small>{{ sort_blu ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                    </v-btn>
                  </v-col>
                  <!-- Verde -->
                  <v-col :cols="show_confronta ? 1 : 2" class="font-weight-medium text-caption d-flex justify-end align-center pr-2" style="color: #00C853;">
                    Verde
                    <v-btn icon x-small @click="sort_verde = !sort_verde; sort_by = 'Verde'">
                      <v-icon small>{{ sort_verde ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                    </v-btn>
                  </v-col>
                  <!-- Totale -->
                  <v-col :cols="show_confronta ? 1 : 2" class="font-weight-medium text-caption d-flex justify-end align-center pr-2 grey--text">
                    Tot
                    <v-btn icon x-small @click="sort_tot = !sort_tot; sort_by = 'Totale'">
                      <v-icon small>{{ sort_tot ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                    </v-btn>
                  </v-col>
                  <template v-if="show_confronta">
                    <v-col cols="1" class="font-weight-medium text-caption d-flex justify-end pr-2 indigo--text text--lighten-2">
                      Blu Rif.
                    </v-col>
                    <v-col cols="1" class="font-weight-medium text-caption d-flex justify-end pr-2 teal--text text--lighten-1">
                      Verde Rif.
                    </v-col>
                    <v-col cols="1" class="font-weight-medium text-caption d-flex justify-end pr-2 grey--text">
                      Tot. Rif.
                    </v-col>
                    <v-col cols="1" class="font-weight-medium text-caption d-flex justify-end pr-2 grey--text">
                      Variazione €
                      <v-btn icon x-small @click="sort_var = !sort_var; sort_by = 'Variazione'">
                        <v-icon small>{{ sort_var ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                      </v-btn>
                    </v-col>
                    <v-col cols="1" class="font-weight-medium text-caption d-flex justify-end pr-1 grey--text">
                      Var %
                    </v-col>
                  </template>
                </v-row>
              </v-card-subtitle>
              <v-card-text>
                <div class="scroll">
                  <AnalisiElement
                    v-for="(item, index) in clienti_filtered"
                    :key="index"
                    :item="item"
                    :show_confronta="show_confronta"
                    :max_totale="max_totale"
                    @select="apriDettaglio(item)"
                  />
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </template>
    </v-card-text>

    <DialogoAnalisiCliente
      v-model="dialog_dettaglio"
      :item="cliente_selezionato"
      :ts_inizio="ts_inizio"
      :ts_fine="ts_fine"
      :show_confronta="show_confronta"
      :anno_rif="anno_rif"
    />
  </v-card>
</template>

<script>
import moment from "moment";
import AnalisiElement from "./analisi_cliente_element.vue";
import DialogoAnalisiCliente from "./dialogo_analisi_cliente.vue";

export default {
  components: {
    AnalisiElement,
    DialogoAnalisiCliente,
  },
  data() {
    return {
      loading: false,
      dialog_dettaglio: false,
      cliente_selezionato: null,
      cliente_search: "",
      anno_rif: 1,
      lista_anni_rif: [
        { label: moment().year() - 1, value: 1 },
        { label: moment().year() - 2, value: 2 },
        { label: moment().year() - 3, value: 3 },
      ],
      periodo_list: [
        { label: "Ultima settimana", value: 7 },
        { label: "Ultimo mese", value: 30 },
        { label: "Ultimi 3 mesi", value: 90 },
        { label: "Anno corrente", value: 0 },
      ],
      periodo: 0,
      show_confronta: false,
      sort_by: "Totale",
      sort_tot: false,
      sort_blu: false,
      sort_verde: false,
      sort_cliente: true,
      sort_var: false,
      usa_contabili:
        localStorage.getItem("usa_contabili_analisi_cliente") === "true" ||
        false,
    };
  },
  mounted() {
    this.fetch_analisi_cliente();
  },
  watch: {
    periodo: function () {
      this.fetch_analisi_cliente();
      if (this.show_confronta) {
        this.fetch_confronto();
      }
    },
    show_confronta: function () {
      if (this.show_confronta) {
        this.fetch_confronto();
      }
    },
    usa_contabili: function () {
      localStorage.setItem("usa_contabili_analisi_cliente", this.usa_contabili);
      this.fetch_analisi_cliente();
      if (this.show_confronta) {
        this.fetch_confronto();
      }
    },
    anno_rif: function () {
      this.fetch_confronto();
    },
  },
  computed: {
    ts_inizio() {
      const jan1 = moment().startOf("year");
      if (this.periodo === 0) return jan1.format("X");
      const subtracted = moment().subtract(this.periodo, "days").startOf("day");
      return moment.max(subtracted, jan1).format("X");
    },
    ts_fine() {
      return moment().format("X");
    },
    kpi() {
      const n_clienti = this.lista_filtered.filter((el) => el.value.totale > 0).length;
      return { n_clienti };
    },
    max_totale() {
      if (!this.lista_filtered.length) return 1;
      return Math.max(...this.lista_filtered.map((el) => el.value.totale)) || 1;
    },
    lista_clienti() {
      return this.$store.getters.get_analisi_clienti;
    },
    lista_clienti_confronto() {
      return this.$store.getters.get_analisi_clienti_confronto;
    },
    lista_clienti_merged() {
      // mappa: iva -> stat di confronto
      const mapConfronto = new Map(
        this.lista_clienti_confronto.map((el) => [el.iva, el.stat])
      );

      // unisco le due stat per stessa iva
      return this.lista_clienti.map((el) => ({
        ...el,
        stat_corrente: el.stat,
        stat_confronto: mapConfronto.get(el.iva) || null,
      }));
    },
    clienti() {
      return this.$store.getters.get_clienti;
    },
    lista_filtered() {
      
      return this.lista_clienti_merged.map((element) => {
        let verde =
          element.stat_corrente.verde_non_saldato +
          element.stat_corrente.verde_saldato -
          (element.stat_corrente.solo_iva_non_saldato +
            element.stat_corrente.solo_iva_saldato) *
            10;
        let blu =
          element.stat_corrente.blu_non_saldato +
          element.stat_corrente.blu_saldato +
          (element.stat_corrente.solo_iva_non_saldato +
            element.stat_corrente.solo_iva_saldato) *
            10 +
          (element.stat_corrente.solo_iva_non_saldato +
            element.stat_corrente.solo_iva_saldato);
        let blu_confronto = element.stat_confronto
          ? element.stat_confronto.blu_non_saldato +
            element.stat_confronto.blu_saldato +
            (element.stat_confronto.solo_iva_non_saldato +
              element.stat_confronto.solo_iva_saldato) *
              10 +
            (element.stat_confronto.solo_iva_non_saldato +
              element.stat_confronto.solo_iva_saldato)
          : 0;
        let verde_confronto = element.stat_confronto
          ? element.stat_confronto.verde_non_saldato +
            element.stat_confronto.verde_saldato -
            (element.stat_confronto.solo_iva_non_saldato +
              element.stat_confronto.solo_iva_saldato) *
              10
          : 0;
        return {
          iva: element.iva,
          cliente: this.$store.getters.get_cliente_by_iva(element.iva).nome,
          value: {
            verde: verde,
            blu: blu,
            totale: verde + blu,
          },
          value_confronto: {
            verde: verde_confronto,
            blu: blu_confronto,
            totale: verde_confronto + blu_confronto,
          },
        };
      });
    },
    lista_sorted() {
      switch (this.sort_by) {
        case "Cliente":
          return this.lista_filtered
            .slice()
            .sort((a, b) => a.cliente.localeCompare(b.cliente));

        case "Blu":
          return this.lista_filtered
            .slice()
            .sort((a, b) => b.value.blu - a.value.blu);
        case "Verde":
          return this.lista_filtered
            .slice()
            .sort((a, b) => b.value.verde - a.value.verde);
        case "Totale":
          return this.lista_filtered
            .slice()
            .sort((a, b) => b.value.totale - a.value.totale);
        case "Variazione":
          return this.lista_filtered
            .slice()
            .sort((a, b) => {
              const da = (a.value.totale || 0) - (a.value_confronto.totale || 0);
              const db = (b.value.totale || 0) - (b.value_confronto.totale || 0);
              return this.sort_var ? da - db : db - da;
            });
        default:
          return this.lista_filtered;
      }
    },
    clienti_filtered() {
      if (this.cliente_search.length < 3) {
        return this.lista_sorted;
      }
      let regex = new RegExp(this.cliente_search, "i");
      return this.lista_sorted.filter((element) => {
        return regex.test(element.cliente);
      });
    },
  },
  methods: {
    fetch_analisi_cliente() {
      this.loading = true;
      this.$store
        .dispatch("fetch_analisi_clienti", {
          ts_inizio: this.ts_inizio,
          ts_fine: this.ts_fine,
          confronto: false,
          usa_contabili: this.usa_contabili,
        })
        .finally(() => { this.loading = false; });
    },
    fetch_confronto() {
      this.$store.dispatch("fetch_analisi_clienti", {
        ts_inizio: moment.unix(this.ts_inizio).subtract(this.anno_rif, "year").format("X"),
        ts_fine: moment.unix(this.ts_fine).subtract(this.anno_rif, "year").format("X"),
        confronto: true,
        usa_contabili: this.usa_contabili,
      });
    },
    apriDettaglio(item) {
      this.cliente_selezionato = item;
      this.dialog_dettaglio = true;
    },
  },
};
</script>

<style scoped>
::-webkit-scrollbar {
  width: 2px;
}
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
::-webkit-scrollbar-thumb {
  background: #bbbbbb;
}
.scroll {
  height: 420px;
  overflow-y: scroll;
  overflow-x: hidden;
}
</style>